export default __webpack_public_path__ + "static/heroSectionBackground-4220ca59586ef2443214464abcecc191.png";